import type { PaginatedResponse } from '@/shared/types/api.types';

import type { Customer, Pro20Page } from '../types/customer.types';

function isPro20Page<T>(value: unknown): value is Pro20Page<T> {
  return (
    typeof value === 'object' &&
    value !== null &&
    'content' in value &&
    Array.isArray((value as Pro20Page<T>).content)
  );
}

/** Normalizes PRO20 customer list results into a paginated shape for the UI */
export function normalizeCustomersResponse(
  results: Pro20Page<Customer> | Customer[] | Customer,
  fallbackSize = 20,
): PaginatedResponse<Customer> {
  if (isPro20Page<Customer>(results)) {
    return {
      data: results.content,
      meta: {
        page: results.number + 1,
        limit: results.size,
        total: results.totalElements,
        totalPages: Math.max(results.totalPages, 1),
      },
    };
  }

  if (Array.isArray(results)) {
    return {
      data: results,
      meta: {
        page: 1,
        limit: results.length || fallbackSize,
        total: results.length,
        totalPages: 1,
      },
    };
  }

  return {
    data: [results],
    meta: {
      page: 1,
      limit: fallbackSize,
      total: 1,
      totalPages: 1,
    },
  };
}
